import WageQualityPage from './WageQualityPage';
export default WageQualityPage;
